import React, { useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import cn from 'classnames';
import Page from '@Containers/Page';
import InProductMessages from '@Containers/InProductMessages';
import Auth from '@Services/Auth';
import { FEATURES } from '@Constants/rx-ui/constants';
import PropTypes from 'prop-types';
import SimpleSpinner from '../../Components/Results/utils/SimpleSpinner';
import { initializeQuickSearch } from './QuickSearchActions';
import BuildQuery from './Components/BuildQuery/BuildQueryContainer';
import QuickResults from './Components/QuickResults/QuickResultsContainer';
import { QUICK_SEARCH_ROUTE, QUICK_SEARCH_ROUTES } from './routes';
import { SPINNER_ID } from './QuickSearchConstants';

function QuickSearch({ action, searchId }) {
  const [initialized, setInitialized] = useState(false);
  const isAIQuickSearchBannerDisabled = Auth.isFeatureEnabled(FEATURES.disableAIQuickSearchBanner);

  useEffect(() => {
    initializeQuickSearch(action).then(() => {
      setInitialized(true);
    });
  }, [action]);

  // FR-1.1/FR-1.3/FR-3.1: this one component serves BOTH the Quick Search query route
  // (`/search/quick/query` = `paths.SEARCH`) and the Preview Results route
  // (`/search/quick/results` = `paths.PREVIEW`). Both are "nothing sticky" pages, achieved by
  // rendering the header INSIDE the `.react-page` scroll root so it scrolls away with the content
  // (FR-1.3). `Main.jsx` suppresses its sibling global header for both routes, so this component
  // must always render its own header inside — hence the prop is unconditionally true.
  return (
    <Page headerType="main" withFooter pageClassName="quick-search-page" renderHeaderInsideScrollRoot>
      <main
        className={cn('quick-search page-container', { 'page-container--hexagons': isAIQuickSearchBannerDisabled })}
        aria-label="Quick Search"
        data-e2e="quick-search-page">
        <InProductMessages />
        {initialized ? (
          <Switch>
            <Route path={QUICK_SEARCH_ROUTE} exact render={() => <SimpleSpinner id={SPINNER_ID} />} />
            <Route path={QUICK_SEARCH_ROUTES.QUERY} render={() => <BuildQuery />} />
            <Route path={QUICK_SEARCH_ROUTES.RESULTS} render={() => <QuickResults key={searchId} searchId={searchId} />} />
          </Switch>
        ) : (
          <SimpleSpinner id={SPINNER_ID} />
        )}
      </main>
    </Page>
  );
}

QuickSearch.propTypes = {
  action: PropTypes.string,
  searchId: PropTypes.string,
};

export default QuickSearch;
